import { ComponentProps } from 'react';
import { Badge } from '../../../../../design-system/badge/badge';
import { exhaustiveCheck } from '../../../../../utils/exhaustive-check';
import { PaidInvoiceMatchingStatus } from './get-paid-invoice-matching-status';

type BadgeVariant = Extract<ComponentProps<typeof Badge>['variant'], 'neutral' | 'negative' | 'positive' | 'attention'>;

export const getPaidInvoiceMatchingStatusBadgeVariant = (status: PaidInvoiceMatchingStatus): BadgeVariant => {
  switch (status) {
    case 'Paid via Seapoint':
      return 'positive';
    case 'Unknown':
    case 'Automatched':
    case 'Manually matched':
      return 'neutral';
    default:
      return exhaustiveCheck(status);
  }
};
